import React from 'react';
import parse from 'html-react-parser';
import {
    FieldWrapper,
} from "@progress/kendo-react-form";
import {
    Label,
} from "@progress/kendo-react-labels";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { getFontWeight } from '../../helpers/StyleHelpers';

function DropDownListFieldWrapper({
    title = "",
    adaptiveTitle = "",
    disabled = false,
    onChange = null,
    data = [],
    dataItemKey = "",
    textField = "",
    value = null,
    boldTitle = false,
    adaptive = false,
    isRequired = false
}) {

    return (
        <FieldWrapper>
            <Label className="k-form-label font-size-md" style={{
                fontWeight: boldTitle ? "700" : "normal"
            }}>
                {parse(title)}:
                {isRequired && <span style={{ color: "var(--warning-bg)", marginLeft: "0.25em" }}>*</span>}
            </Label>
            <div className="k-form-field-wrap">
                <DropDownList
                    disabled={disabled}
                    data={data}
                    dataItemKey={dataItemKey}
                    textField={textField}
                    adaptive={adaptive}
                    adaptiveTitle={adaptiveTitle}
                    value={value}
                    onChange={onChange}
                    className="font-size-lg"
                />
            </div>
        </FieldWrapper>
    );
}

export default DropDownListFieldWrapper;
